import React from 'react';
import styles from './Modal.module.scss';
const ModalChildrenContainer = ({ children, noOverflow, className }) => {
  return (
    <div
      style={{ overflow: noOverflow ? 'visible' : '' }}
      className={`${styles['status-container']} ${className}`}
    >
      {' '}
      {children}
    </div>
  );
};

export default ModalChildrenContainer;
